import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { Banner, DrawerBodyWrapper, Select, TOAST_TYPE, UploadButton } from '@base'
import { FormItemWrapper } from '../WeightCalculator/styles'
import { BannerText, StepTopWrapper } from '../InvoiceEndorsement/styles'
import { strings } from '@constants'
import { Devices, Spacings } from '@styles'
import { uploadDashboardReportApi } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { useHeaderMeta } from '@hooks'
import { adminToolDashboardReport } from '@utils'

const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_3B};
	margin-top: ${Spacings.SPACING_3B};
	@media ${Devices.mobile} {
		flex-direction: row;
	}
`

const SelectWrapper = styled.div`
	width: 100%;
	@media ${Devices.mobile} {
		width: 15vw;
	}
`

const UploadWrapper = styled.div`
	width: 100%;
	& > button {
		width: 100%;
	}
	@media ${Devices.mobile} {
		width: auto;
		& > button {
			width: auto;
		}
	}
`

const NoteWrapper = styled(StepTopWrapper)`
	margin-top: ${Spacings.SPACING_4B};
`

export const reportTypeList = [
	{ key: 'BUSINESS_DASHBOARD', label: 'Monthly Business Dashboard' },
	// { key: 'CUSTOMER_AVG_DELAYED', label: 'Customer Average Delayed' },
]

const UploadDashboardReport = () => {
	const dispatch = useDispatch()
	const loggedInUser = useSelector((state) => state.getIn(['user', 'user']))
	const [reportType, setReportType] = useState(reportTypeList[0])

	useHeaderMeta(adminToolDashboardReport)

	const uploadDashboardReport = (selectedFile) => {
		dispatch(showLoader(true))
		uploadDashboardReportApi(loggedInUser?.user_id, selectedFile, reportType?.key)
			.then((response) => {
				dispatch(showToast(true, strings('msg_dashboard_html_file_uploaded_successfully'), { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((error) => {
				dispatch(
					showToast(true, error?.response?.data?.message || strings('msg_dashboard_html_file_uploaded_failure'), { type: TOAST_TYPE.ERROR })
				)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	const onFileSelected = (selectedFile) => {
		if (!selectedFile) return
		uploadDashboardReport(selectedFile)
	}

	return (
		<DrawerBodyWrapper>
			<FormItemWrapper>
				<FormWrapper>
					<SelectWrapper>
						<Select
							label={strings('dashboard_report_type')}
							id='report-input-type'
							placeholder={strings(['select', 'dashboard_report_type'])}
							value={reportType ?? {}}
							onChange={setReportType}
							data={reportTypeList}
							displayKey='label'
							primaryKey='key'
							required
							small
						/>
					</SelectWrapper>
					<UploadWrapper>
						<UploadButton
							accept='html'
							label={strings('upload_dashboard_report')}
							disabled={!reportType}
							small
							uppercase
							onChange={onFileSelected}
						/>
					</UploadWrapper>
				</FormWrapper>
				<NoteWrapper>
					<Banner
						extendInMobile
						text={
							<BannerText>
								<span>* {strings('file_should_be_html_only')}</span>
							</BannerText>
						}
					/>
				</NoteWrapper>
			</FormItemWrapper>
		</DrawerBodyWrapper>
	)
}

export default UploadDashboardReport
